import { asContainer } from 'lib/container'

import { HeaderIconUnauthenticated } from 'components/Icons'
import { SplashScreen } from 'components/Layout'

export const container = asContainer<{}>()({
	authentication: { type: 'public' },
	Running: () => (
		<SplashScreen
			title='You do not have the proper credentials to access this page.'
			icon={<HeaderIconUnauthenticated />}
		/>
	),
})
